import React, { useContext } from "react";
import { Grid, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import FeatherIcon from "feather-icons-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AppDataContext } from "../../components/context/app-data-context.jsx";
import UploadDialogue from "../../components/upload/upload-dialogue";
import { tabselected } from "../../consts.js";
import Utils from "../../utils";
import CampaignArchive from "./campaign-archived";
import CampaignConversations from "./campaign-conversations";
import CampaignInsights from "./campaign-insights";
import { useThemeMode } from "../../components/theme/index.jsx";
import { generateTranscriptAPI } from "../../services/conversation.js";

function Campaign() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const [campaignId] = React.useState(params.get("id") || "");
    if (!campaignId) {
        navigate("/campaigns");
    }
    const AppDataContextDTO = useContext(AppDataContext);

    const [selectedTab, setSelectedTab] = React.useState("Campaign insights");
    const [campaignData, setCampaignData] = React.useState({
        name: "",
        type: "",
        company: { name: "" },
    });
    const [updated, setUpdated] = React.useState(0);

    const [open, setOpen] = React.useState(false);
    const [dataLoaded, setDataLoaded] = React.useState(false);
    const [spinner, setSpinner] = React.useState(false);
    const { colours, FONT } = useThemeMode();

    const handleTabClick = (tabName) => {
        setOpen(true); // Open the dialog when the tab is clicked
    };

    async function getCampaignData() {
        setSpinner(true);
        Utils.sendProgressBar(true);
        const campaign = await Utils.genericGet("getCampaign", campaignId);

        // set data for breadcrumb
        AppDataContextDTO.setCampaign({
            id: campaignId,
            name: campaign.data.getCampaign.name
        });
        setCampaignData(campaign.data.getCampaign);
        setSpinner(false);
        Utils.sendProgressBar(false);
    }

    React.useEffect(() => {
        try {
            AppDataContextDTO.clearAppData();
        } catch (error) {

        }
    }, [])

    React.useEffect(() => {
        if (!dataLoaded && campaignId) {
            const fetchData = async () => {
                await getCampaignData(); // Your async data fetching function
                setDataLoaded(true); // Mark data as loaded
            };
            fetchData();
        }
        window.scrollTo(0, 0); // Scroll to top when component mounts
    }, [dataLoaded, campaignId]);

    const returnToCampaigns = () => {
        navigate("/campaigns");
    }

    return (
        <Grid display="flex" flexDirection="column" flexGrow="1" overflow="auto">
            {spinner && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                    }}
                >
                    <CircularProgress style={{ color: colours.primary100 }} />
                </div>
            )}
            {/* <Stack gap={1} flexDirection="row" flexWrap="wrap" alignItems="center" sx={{ wordBreak: 'break-word', padding: { xs: "10px 12px", md: "10px 24px" } }}>
                <Stack flexDirection="row" gap={.5}>
                <FeatherIcon icon="award" style={{ flexShrink: 0 }} />
                <Link component="button" underline="none" color="inherit" onClick={returnToCampaigns}>Campaigns /</Link>
                </Stack>
                <Stack flexDirection="row" gap={.5}>
                <FeatherIcon icon="list" style={{ flexShrink: 0 }} />
                <Typography component="div" sx={{ fontWeight: "bolder", borderBottom: "solid 2px" }}>{campaignName}</Typography>
                </Stack>
            </Stack> */}
            <Grid
                display="flex"
                flexDirection="row"
                flexWrap="wrap"
                borderBottom={colours.dividergraybottomborder}
                paddingX={1}
                alignItems="center"
            >
                <Typography
                    component="div"
                    display="flex"
                    flexDirection="row"
                    marginRight="auto"
                    alignItems={{ xs: 'end', sm: 'normal' }}
                >
                    <Typography component="div"
                        sx={tabselected(selectedTab === "Campaign insights", colours, FONT)}
                        onClick={() => setSelectedTab("Campaign insights")}
                    >
                        Campaign Insights
                    </Typography>
                    <Typography component="div"
                        sx={tabselected(selectedTab === "Processed conversations", colours, FONT)}
                        onClick={() => setSelectedTab("Processed conversations")}
                    >
                        Processed Conversations
                    </Typography>
                    <Typography component="div"
                        sx={tabselected(selectedTab === "Archived", colours, FONT)}
                        onClick={() => setSelectedTab("Archived")}
                    >
                        Archived
                    </Typography>
                </Typography>
                <Typography component="div" sx={{ order: { xs: '-1', sm: '0' }, paddingTop: { xs: 1, sm: 0 }, flexGrow: { xs: 1, sm: 0 } }}>
                    <Button
                        variant="contained"
                        onClick={() => handleTabClick("Upload Conversation")}
                        startIcon={<FeatherIcon icon="upload" size={20} />}
                        sx={{ width: { xs: "100%", sm: "auto" } }}
                    >
                        Upload
                    </Button>
                </Typography>
            </Grid>

            {selectedTab === "Campaign insights" && <CampaignInsights />}
            {selectedTab === "Processed conversations" && <CampaignConversations updated={updated} />}
            {selectedTab === "Archived" && <CampaignArchive />}

            {/* Upload Dialogue */}
            <UploadDialogue
                open={open}
                onClose={() => setOpen(false)} // Close the dialog when onClose is triggered
                campaignData={campaignData}
                onSuccess={(createdConversationId) => {
                    setUpdated(updated + 1);
                    generateTranscriptAPI(createdConversationId)
                }}
            />
        </Grid>
    );
}

export default Campaign;
